import React, { useEffect, useState, useCallback } from 'react';
import {Box, Typography, Paper, TextField, CircularProgress} from '@mui/material';
import { apiRemote } from '@/api/wp-api';
import CoursesList from './components/CoursesList';
import { useAlert } from "@/contexts/AlertContext";
import img_course from '../../images/imgcourse.png';

// Thêm interface để định nghĩa kiểu dữ liệu từ API
interface ICourse {
    id: number;
    coursename: string;
    summary: string;
    view_url: string;
    course_image: string;
    last_access_time: string;
    total_activity: number;
    total_activity_completion: number;
    completionPercentage: number;
    isEnrolled?: boolean; // thêm trường này để phân biệt khóa học đã đăng ký
}

interface ICourseResponse {
    count: number;
    data: ICourse[];
}

// Thêm interface cho activity_info
interface IActivityInfo {
    cmid: number;
    modname: string;
    activity_image: string;
    instance: number;
    activity_name: string;
    timecompleted: string;
    activity_url: string;
}

interface ICompletedActivity {
    coursename: string;
    view_url: string;
    categoryname: string;
    activity_info: IActivityInfo;
}

interface ICompletedActivityResponse {
    totalItems: number;
    completedActivities: ICompletedActivity[];
}

const MyCourses1 = () => {
    const [loading, setLoading] = useState(false);
    const [myCourses, setMyCourses] = useState<ICourse[]>([]);
    const [allCourses, setAllCourses] = useState([]);
    const [search, setSearch] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(4);
    const [totalItems, setTotalItems] = useState(0);
    const alert=useAlert();

    const loadData = useCallback(async () => {
        setLoading(true);
        try {
            const [courseResponse] = await Promise.all([
                apiRemote.getMyCourse(currentPage.toString(), pageSize.toString(), searchQuery)
            ]);
            
            // Xử lý dữ liệu cho MyCourses (các khóa học đã đăng ký)
            const enrolledCourses = courseResponse.data.course_details
                .filter((course: ICourse) => course.last_access_time)
                .map((course: ICourse) => ({
                    id: course.id.toString(),
                    title: course.coursename,
                    completedActivities: course.total_activity_completion,
                    totalActivities: course.total_activity,
                    completionPercentage: course.completionPercentage,
                    imageUrl: course.course_image || img_course,
                    viewUrl: course.view_url
                }));

            setMyCourses(enrolledCourses);
            setTotalItems(courseResponse.data.total_course_enrolled || 0);
        } catch (error) {
            // alert.error('Error loading data');
            console.log(error)
        } finally {
            setLoading(false)
        }
    }, [currentPage, pageSize, searchQuery, alert]);

    useEffect(() => {
        loadData();
    }, [currentPage, pageSize, searchQuery]); // Thêm searchQuery vào dependencies

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (value: string) => {
        setSearch(value);
    };

    const handleSearchSubmit = (value: string) => {
        setSearchQuery(value.trim());
        setCurrentPage(1);
    };

    return (
        <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 1 }}>
            <TextField
                fullWidth
                variant="outlined"
                placeholder="Search by Course Name, Course ID"
                value={search}
                onChange={(e) => handleSearchChange(e.target.value)}
                onKeyPress={(e) => {
                    if (e.key === 'Enter' && search.trim() !== '') {
                        handleSearchSubmit(search);
                    }
                }}
                sx={{ mb: 3 }}
            />
            
            {/* My Courses Section */}
            {/* <Paper sx={{ mb: 3, p: 2 }}> */}
                <Typography 
                    variant="h5" 
                    sx={{ 
                        mb: 2,
                        color: "rgb(15, 105, 185)", // Màu xanh đậm cho tiêu đề
                        fontSize: '20px',
                        fontWeight: 600
                    }}
                >
                    Enrolled Courses
                </Typography>
                
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                        <CircularProgress />
                    </Box>
                ) : myCourses.length === 0 ? (
                    <Typography
                        sx={{
                            color: "rgb(102, 102, 102)",
                            fontSize: "1rem",
                            textAlign: "center"
                        }}
                    >
                        No data available
                    </Typography>
                ) : (
                    <CoursesList
                        courses={myCourses}
                        loading={loading}
                        search={search}
                        showSearchField={false}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        totalItems={totalItems}
                        onPageChange={handlePageChange}
                        onSearchChange={handleSearchChange}
                        onSearchSubmit={handleSearchSubmit}
                    />
                )}
            {/* </Paper> */}
        </Box>
    );
};

export default MyCourses1;